var styleDataHash = "a473935c";
const injectCss = () => {
  var css = `._8ZU4j{display:flex}[dir] ._8ZU4j{margin:0}.t9ATh{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:inherit;font-weight:inherit;line-height:28px;max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}[dir] .t9ATh{margin:0;padding:0 4px}.t9ATh:hover{text-decoration:underline}.t9ATh:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.t9ATh._70muk{line-height:32px}[dir] ._62CGT{background:transparent;border:0}[dir] ._62CGT:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:640px){.t9ATh{max-width:160px}}}@container (width < 640px){.t9ATh{max-width:160px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var url_link_button_default = {
  "toolbarUrlContainer": "_8ZU4j",
  "toolbarUrl": "t9ATh",
  "isMobile": "_70muk",
  "toolbarUrlAnchor": "_62CGT"
};
export {
  url_link_button_default as default,
  injectCss
};
//# sourceMappingURL=url-link-button-scss.js.map
